import axios from "axios";
import { toast } from "react-toastify";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});


// 🔐 REQUEST → agrega token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ❌ RESPONSE → token expirado
instance.interceptors.response.use(
  (response) => response,
  (error) => {

    const originalRequest = error.config;

    if (error.response?.status === 401) {

      // 🔥 NO hacer nada si el error viene del login
      if (originalRequest.url.includes("/users/login")) {
        return Promise.reject(error);
      }

      toast.info("Tu sesión expiró, vuelve a iniciar sesión");

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    }

    return Promise.reject(error);
  }
);
export default instance;
